/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ letter: NonNullable<unknown> }} Sharedplan_DayInputs */

const en_us2_sharedplan_day = /** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.letter}`)
};

const pt_br2_sharedplan_day = /** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.letter}`)
};

const pt_pt2_sharedplan_day = /** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.letter}`)
};

/** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */
const es_419_sharedplan_day = en_us2_sharedplan_day;

/** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */
const fr_fr2_sharedplan_day = en_us2_sharedplan_day;

/** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */
const de_de2_sharedplan_day = en_us2_sharedplan_day;

/** @type {(inputs: Sharedplan_DayInputs) => LocalizedString} */
const it_it2_sharedplan_day = en_us2_sharedplan_day;

/**
* | output |
* | --- |
* | "Workout {letter}" |
*
* @param {Sharedplan_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_day = /** @type {((inputs: Sharedplan_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_day(inputs)
	if (locale === "es-419") return es_419_sharedplan_day(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_day(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_day(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_day(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_day(inputs)
	return en_us2_sharedplan_day(inputs)
});
export { sharedplan_day as "sharedplan.day" }